import { render, staticRenderFns } from "./fiji.vue?vue&type=template&id=40513aab&scoped=true&"
import script from "./fiji.vue?vue&type=script&lang=js&"
export * from "./fiji.vue?vue&type=script&lang=js&"
import style0 from "./fiji.vue?vue&type=style&index=0&id=40513aab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40513aab",
  null
  
)

export default component.exports